import { BEMUSIC_CONFIG } from './bemusic-config';
var ɵ0 = BEMUSIC_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
